// extracted by mini-css-extract-plugin
export default {"title":"Home_title__uyXwl","container":"Home_container__403L-"};